import { render } from "./NewCardModal.vue?vue&type=template&id=1627b227"
import script from "./NewCardModal.vue?vue&type=script&lang=ts"
export * from "./NewCardModal.vue?vue&type=script&lang=ts"
script.render = render

export default script